import { render, staticRenderFns } from "./ConfigPassword.vue?vue&type=template&id=2823a08b&scoped=true"
import script from "./ConfigPassword.vue?vue&type=script&lang=js"
export * from "./ConfigPassword.vue?vue&type=script&lang=js"
import style0 from "./ConfigPassword.vue?vue&type=style&index=0&id=2823a08b&prod&lang=css"
import style1 from "./ConfigPassword.vue?vue&type=style&index=1&id=2823a08b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823a08b",
  null
  
)

export default component.exports